/*satis.12yazilim@gmail.com
 https://www.bulut12.com/login/google/callback
 */
export const Config = {
    googleOAuthClientId:'489428291501-30o07h0s5d379q59ef7radhgh6kn0ssc.apps.googleusercontent.com',
    gAnalyticsId: 'G-43QB5R8KHZ',
    apiHost: 'https://site.${domain}:33103/'
}